<template>
	<div>
		<navigation-component></navigation-component>
		<div class="main-content" id="panel">
	  		<header-component></header-component>
	  		<!-- Header -->
	  		<div class="header bg-gradient-default pb-6 d-flex align-items-center">
	  			<!-- Mask -->
	  			<span class="mask bg-gradient-default opacity-1"></span>
	  			<!-- Header container -->
	  			<div class="container-fluid text-white  align-items-center">
	  				<div class="row">
	  					<div class="col-lg-7 col-md-10 mt-4">
	  						<h1 class="display-3 text-white">Bienvenido</h1>
	  						<p class="mt-0 mb-5">
	  						Seleccione una solución</p>
	  					</div>
	  				</div>
	  			</div>
	  		</div>
	  		<!-- Page content -->

	  		<div class="container-fluid mt--6">
				<div class="row" v-if="productosusuario.length ==  0">
					<div class="col-sm-4">
						<div class="card bg-gradient-lighter">
							<div class="card-body">
	  							<div class="row">
	  								<div class="col">
	  									<h5 class="card-title mb-0 ">No tiene productos activos, por favor de clic en Comprar para adquirir sus productos.</h5>
	  								</div>
	  								<div class="col-auto">
	  									<img alt="Image placeholder" src="assets/img/gca_logo.png" width="100" class="img-fluid">
	  								</div>									
	  							</div>
							</div>
							<div style="padding-left: 10px; padding-bottom: 5px;" class="row">
								<div class="col-auto">
	  								<router-link to="/productos" class="btn btn-xs btn-primary" ><i class="ni ni-button-power"></i> Comprar productos</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>

	  			<div class="row" v-else>
	  				<!--columna1-->
	  				<div class="col-sm-4" v-for="(producto, index) in productos" :key="producto.id" :id="'producto' + producto.id">
	  					<!--card de modulo-->
	  					<div class="card bg-gradient-lighter">
	  						<!-- Card body -->
	  						<div class="card-body">
	  							<div class="row">
	  								<div class="col">
	  									<h5 class="card-title mb-0 ">{{producto.nombre}}</h5>
	  								</div>
	  								<div class="col-auto">
	  									<img alt="Image placeholder" :src="producto.imagen" class="img-fluid">
	  								</div>
	  							</div>
	  							<div class="row">
	  								<button type="button" class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="producto.versiones.length > 0" :id="'btnBoton' + producto.id">{{producto.texto_boton}}</button>
	  								<div class="dropdown-menu" v-if="producto.versiones.length > 0">
	  									<div class="dropdown-item text-sm" data-toggle="modal" data-target="#modal-form" @click="id_plataforma = producto.id_plataforma" aria-expanded="false" v-for="(version, index) in producto.versiones" :key="version.id" v-if="producto.id_plataforma != 2 && version.activo == 1">{{version.nombre}}
	  									</div>
	  									<div class="dropdown-item text-sm" @click="ingresar(version.id_plataforma, version.id, version.clave, producto.id)" aria-expanded="false" v-for="(version, index) in producto.versiones" :key="version.id" v-if="producto.id_plataforma == 2 && version.activo == 1">{{version.nombre}}
	  									</div>
	  								</div>
	  								<button type="button" :id="'btnIngresa' + producto.id" class="btn btn-xs btn-primary" @click="ingresar(producto.id_plataforma, 0, 0, producto.id)" v-show="producto.id_plataforma > 0 && producto.id_plataforma != 2"><i class="ni ni-button-power"></i> Ingresar</button>
	  							</div>
	  						</div>
	  					</div>
					</div>
					<!--termina columna 1-->
				</div>
	  		</div>
	  	</div>
	  	<!--Modal de activar curso-->	
		<div class="modal fade" id="modal-form" role="dialog" aria-labelledby="modal-form" aria-hidden="true">
			<div class="modal-dialog modal- modal-dialog-centered modal-lg" role="document">
				<div class="modal-content">
					
					<div class="modal-body p-0">
						
						
						<div class="card bg-secondary border-0 mb-0">
							
							<div class="card-body px-lg-5 py-lg-5">
								<div class="text-center text-muted mb-4">
									<small v-if="id_plataforma != 3">Escribe tu código y haz clic en "Activar curso", si no tienes un código de activación puedes <br><br> <a href="#" @click.prevent="goToStore()" class="btn btn-xs btn-neutral"><i class=" ni ni-cart"></i> Comprarlo aquí</a></small>
								</div>
								<vue-form :state="formstate" @submit.prevent="create()">
									
									<div class="form-group">
										<validate tag="div">
											<div class="input-group input-group-merge input-group-alternative">
												<div class="input-group-prepend">
													
												</div>
												<input class="form-control" v-model="model.codigo" placeholder="Ingresa tu código aquí" type="text" required name="codigo" autocomplete="off">
											</div>
											<field-messages name="codigo" show="$invalid && $submitted" class="text-danger">
												<div slot="required">El código de activación es requerido</div>
											</field-messages>
										</validate>
									</div>
									<div class="form-group" v-if="id_plataforma != 3">
										<p>
											Nota: Si estás tratando de activar un código para un simulador, debes de dar clic en la opción de "activar código de simulador"
										</p>
									</div>
									<div class="form-group" v-if="id_plataforma == 3">
										<p>Tus códigos de simulador aparecen aquí, si no tienes presiona el botón "Solicitar códigos de simulador"</p>
										<template v-for="codigo in codigosUsuario">
											<div :key="codigo.id">
												<p v-for="simulador in codigo.codigosSimulador" :key="simulador.id">{{ simulador.codigo }} | {{ simulador.nombreVersion }}</p>
											</div>
										</template>
									</div>
									<div class="text-center">
										<button type="submit" class="btn btn-primary my-4" data-toggle="#modal-form">{{textoBotonCodigo}}</button>
										<button type="button" class="btn btn-primary my-4" v-if="id_plataforma == 3 && codigosSimulador == 0 && puedeActivarGmetrix == 1" @click.prevent="solicitaSimuladores">Solicitar códigos de simulador</button>
									</div>
								</vue-form>
							</div>
						</div>

						
					</div>
					
				</div>
			</div>
		</div>
		<!--termina Modal activar curso-->
		<!--Modal de activar curso-->	
		<div class="modal fade" id="modal-lingo" role="dialog" aria-labelledby="modal-lingo" aria-hidden="true">
			<div class="modal-dialog modal- modal-dialog-centered modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-body p-0">
						<div class="card bg-secondary border-0 mb-0">
							<div class="card-body px-lg-5 py-lg-5">
								<p>Descarga la APP LingoChamp en tu dispositivo móvil dependiendo el sistema operativo Android o iOS</p>
								<p>Android: <a href="https://play.google.com/store/apps/details?id=com.laix.lingochamp&hl=en" target="_blank">https://play.google.com/store/apps/details?id=com.laix.lingochamp&hl=en</a></p>
								<p>iOS: <a href="https://apps.apple.com/us/app/lingochamp-speaking-english/id1460991582" target="_blank">https://apps.apple.com/us/app/lingochamp-speaking-english/id1460991582</a></p>
								<p>En un lapso de 24 a 48 horas después de haber realizado tu compra en el portal, verifica en tu correo electrónico tu CONTRASEÑA INICIAL para acceder a tu curso.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--termina Modal activar curso-->
		<!--Modal de activar curso-->	
		<div class="modal fade" id="modal-form-group" role="dialog" aria-labelledby="modal-form-group" aria-hidden="true">
			<div class="modal-dialog modal- modal-dialog-centered modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-body p-0">
						<div class="card bg-secondary border-0 mb-0">
							
							<div class="card-body px-lg-5 py-lg-5">
								<div class="text-center text-muted mb-4">
									<small v-if="id_plataforma != 3">Escribe tu código de grupo y haz clic en "Vincularme".<br> Tu docente debe proporciar el código de grupo, también asegúrate de escribirlo correctamente sin espacios.</small>
								</div>
								<vue-form :state="formstate2" @submit.prevent="setGroup()">
									<div class="form-group">
										<validate tag="div">
											<div class="input-group input-group-merge input-group-alternative">
												<div class="input-group-prepend">
												</div>
												<select class="form-control" name="versionGrupo" v-model="model.idVersion">
													<option value="">Selecciona un producto para vincularte</option>
													<template v-for="productoGrupo in productosGrupo">
														<option v-if="productoGrupo.idPlataforma == 2 && productoGrupo.idVersion > 0" :key="productoGrupo.id" :value="productoGrupo.id">{{ productoGrupo.name }}</option>
													</template>
												</select>
											</div>
											<field-messages name="versionGrupo" show="$invalid && $submitted" class="text-danger">
												La versión es requerida
											</field-messages>
										</validate>
									</div>
									<div class="form-group">
										<validate tag="div">
											<div class="input-group input-group-merge input-group-alternative">
												<div class="input-group-prepend">
													
												</div>
												<input class="form-control" v-model="model.codigoGrupo" placeholder="Ingresa tu código aquí" type="text" required name="codigoGrupo" autocomplete="off">
											</div>
											<field-messages name="codigoGrupo" show="$invalid && $submitted" class="text-danger">
												El código de grupo es requerido
											</field-messages>
										</validate>
									</div>
									<div class="text-center">
										<button type="submit" class="btn btn-primary my-4" data-toggle="#modal-form-group">Vincularme</button>
									</div>
								</vue-form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--termina Modal activar curso-->
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueForm from "vue-form"
	import NavigationComponent from '@/components/NavigationComponent'
	import HeaderComponent from '@/components/HeaderComponent'
	import options from "../validations/validations.js";
	Vue.use(VueForm, options);
	export default {
		name: 'Home',
		components: {
			NavigationComponent, HeaderComponent
		},
		data() {
			return {
				productos: [],
				formstate: {},
				formstate2: {},
				id_plataforma: 0,
				productosusuario: [],
				textoBotonCodigo: 'Activar curso',
				model: {
					codigo: '',
					password: '',
					codigoGrupo: '',
					idVersion: '',
				},
				usuario: user,
				codigosUsuario: [],
				codigosSimulador: 0,
				faltanSimuladores: 0,
				puedeActivarGmetrix: 0,
				hostname: '',
				//classHeader: 'header bg-gradient-default pb-6 d-flex align-items-center',
				//classTextWelcome: 'mt-0 mb-5',
				versiones: [],
				productosGrupo: [],
			}
		},

		methods: {
			async create() {
				if (this.formstate.$invalid) {
	                return;
	            } else {
	            	$("#modal-form").modal('hide')
					await this.saveDataNoForm('api/activarcodigo?id_plataforma=' + this.id_plataforma, this.model, '', '', null, 0, 1, null)
					await this.getProductosUsuario(this.usuario.id)
					this.refrescaProds()
	            }
			},

			async ingresar(id_plataforma, id_version, id_exam, id_producto) {

				if(id_producto == 12)
					id_plataforma = 4
				if(id_plataforma == 1){
					// if(navigator.platform.toUpperCase().indexOf('WIN') >= 0) {
						this.openLoading()
						await axios.post(apiKS + 'api/ingresajasper', null, { headers })
						.then( response => {
							Swal.close()
							if(response.data.status == true) {
								//registramos el acceso
								this.registraAcceso(id_producto)
								window.open(response.data.message)
							}
							if(response.data.status == false) {
								Swal.fire({
									icon: 'error',
									title: 'Oops...',
									text: response.data.message,
								})
							}
						})
						.catch( error => {
							this.catchError()
						})
					// } else {
					// 	router.push(`/course-index?platform=${id_plataforma}&product=${id_version}`)
					// }
				}
				if(id_plataforma == 3){
					this.openLoading()
					await axios.post(apiKS + 'api/ingresagmetrix', null, { headers })
					.then( response => {
						Swal.close()
						if(response.data.status == true) {
							window.open(response.data.message)
						}
						if(response.data.status == false) {
							Swal.fire({
					        	icon: 'error',
					        	title: 'Oops...',
					        	text: response.data.message,
					        })
						}
					})
					.catch( error => {
						this.catchError()
					})
				}
				if(id_plataforma == 2){
					// revisamos si tiene activa la versión con algún código activo
					/*const version = this.versiones.find( element => element.id == id_version )
					if(version == undefined) {
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: 'No tiene activo el producto seleccionado, favor de verificar o adquirir un acceso al mismo.',
						})

						return
					}*/
					this.openLoading()
					id_version = 0
					await axios.post(apiKS + 'api/ingresaethinking', { id_version, id_exam, urlRegresa: 'http://localhost:8080/#/home' }, { headers })
					.then( response => {
						Swal.close()
						if(response.data.status == true) {
							let urlLink = response.data.message.replace("p6=1", "p6=2")
							console.log(urlLink)
							this.registraAcceso(id_producto)

							location.href = urlLink
						}
						if(response.data.status == false) {
							Swal.fire({
					        	icon: 'error',
					        	title: 'Oops...',
					        	text: response.data.message,
					        })
						}
					})
					.catch( error => {
						this.catchError()
					})
				}
				if(id_plataforma == 4){
					this.openLoading()
					await axios.post(apiKS + 'api/ingresa-lingo', { id_producto }, { headers })
					.then( response => {
						Swal.close()
						if(response.data.status == true) {
							this.registraAcceso(id_producto)
							$("#modal-lingo").modal('show')
						}
						if(response.data.status == false) {
							Swal.fire({
					        	icon: 'error',
					        	title: 'Oops...',
					        	text: response.data.message,
					        })
						}
					})
					.catch( error => {
						this.catchError()
					})
				}
				if(id_plataforma == 6){
					this.openLoading()
					await axios.post(apiKS + 'api/ingresa-jasper-adobe', null, { headers })
					.then( response => {
						Swal.close()
						if(response.data.status == true) {
							//registramos el acceso
							this.registraAcceso(id_producto)
							window.open(response.data.message)
						}
						if(response.data.status == false) {
							Swal.fire({
								icon: 'error',
								title: 'Oops...',
								text: response.data.message,
							})
						}
					})
					.catch( error => {
						this.catchError()
					})
				}
			},
			async registraAcceso(id_producto) {
				await axios.post(apiKS + 'api/accesos', { id_producto}, { headers })
				.then( response => {
					
				})
				.catch( error => {
					this.catchError()
				})
			},

			async refrescaProds() {
				this.productos.forEach( element => {
					$("#btnBoton" + element.id).hide()
					$("#btnIngresa" + element.id).hide()
					$("#producto" + element.id).hide()
				})

				setTimeout( () => {
					this.productosusuario.forEach( element => {
						$("#btnBoton" + element.id_producto).show()
						$("#producto" + element.id_producto).show()
						if(element.id_plataforma != 2)
							$("#btnIngresa" + element.id_producto).show()
					})
				}, 100)
			},

			async solicitaSimuladores() {
				$("#modal-form").modal('hide')
				let solicitud = []
				this.codigosUsuario.forEach(codigo => {
					// si se creo una orden de compra
					let versiones = []
					if(codigo.tipoCreacion == 3) {
						if(codigo.orden && codigo.codigosSimulador.length == 0) {
							codigo.orden.detalleOrden.forEach(detalle => {
								versiones.push(detalle)
							})
		
							solicitud.push({ codigo: codigo.codigo.codigo, versiones })
						}
					}

					if(codigo.tipoCreacion == 2) {
						if(codigo.codigosSimulador.length == 0) {
							codigo.codigo.productos.map( producto => {
								solicitud.push({ codigo: codigo.codigo.codigo, versiones: producto.versiones })
							} )
						}
					}
				})

				if(solicitud.length == 0) {
					Swal.close()
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'Tus códigos activados no incluyen simulador, si crees que esto es un error, favor de enviar un correo a soporte@gcacademy.online',
					})
					return
				}

				this.openLoading()

				await axios.post(apiKS + 'api/codigos-simulador', {productos: solicitud}, { headers })
				.then( async response => {
					Swal.close()
					if(response.data.status == true) {
						Swal.fire({
                            title: "Exito",
                            text: response.data.message,
                            icon: "success",
						})
						
						await this.getCodigosUsuario()
						this.codigosUsuario.forEach(codigo => {
							this.codigosSimulador = this.codigosSimulador + codigo.codigosSimulador.length
						})
					}

					if(response.data.status == false) {
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: response.data.message,
						})
					}
				})
				.catch( error => {
					this.catchError()
				})
			},
			async setGroup() {
				this.openLoading()
				$("#modal-form-group").modal('hide')
				await axios.post(apiKS + 'api/vincular-grupo', this.model, { headers })
				.then( async response => {
					Swal.close()
					if(response.data.status == true) {
						Swal.fire({
                            title: "Exito",
                            text: response.data.message,
                            icon: "success",
						})
					}

					if(response.data.status == false) {
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: response.data.message,
						})
					}
				})
				.catch( error => {
					this.catchError()
				})
			},
			goToStore() {
				$("#modal-form").modal('hide')
				// this.$router.push('/productos')
			}
		},
		
		async mounted() {
			//$("body").css('background-image', 'none')
			//$("body").css('margin-top', '0px')
			//this.hostname = hostname

			//const script = document.createElement('script')
			//script.src = 'assets/js/argon.js'
			//document.body.appendChild(script)
			
			if(!user) {
                await this.getUserApi()
                this.usuario = user
            }

            this.openLoading()
            await this.getProductos()
			await this.getProductosUsuario(this.usuario.id)
			await this.getCodigosUsuario()

			this.codigosUsuario.forEach(codigo => {
				this.puedeActivarGmetrix = 1
				this.codigosSimulador = this.codigosSimulador + codigo.codigosSimulador.length
				if(codigo.codigosSimulador.length == 0)
					this.faltanSimuladores = 1

				codigo.codigo.productos.forEach( producto => {
					producto.versiones.forEach( version => {
						this.versiones.push(version)
					} )
				} )
			})

			if(this.faltanSimuladores == 1)
				this.codigosSimulador = 0

            this.productos.forEach( element => {
            	$("#btnBoton" + element.id).hide()
            	$("#btnIngresa" + element.id).hide()
            	$("#producto" + element.id).hide()
            })

            setTimeout( () => {
            	this.productosusuario.forEach( element => {
					let producto = undefined
            		$("#btnBoton" + element.id_producto).show()
            		$("#producto" + element.id_producto).show()
            		if(element.id_plataforma != 2)
            			$("#btnIngresa" + element.id_producto).show()

					//llenamos el campo para los grupos
					if(this.productos.find( producto => producto.id == element.id_producto ) != undefined) {
						producto = this.productos.find( producto => producto.id == element.id_producto )
						producto.versiones.forEach( version => {
							let productoGrupo = this.productosGrupo.find(prodGrupo => (prodGrupo.idVersion == version.idversion && prodGrupo.name == producto.nombre + ' (' + version.nombre + ')'))
							if(!productoGrupo) {
								this.productosGrupo.push({
									id: version.id,
									idVersion: version.idversion,
									name: producto.nombre + ' (' + version.nombre + ')',
									idPlataforma: version.id_plataforma,
								})
							}
						} )
					}
            	})
            }, 100)
            Swal.close()

            Fire.$on('setPlataforma', (data) => {
				this.id_plataforma = data.id_plataforma
				this.textoBotonCodigo = 'Activar curso'
				if(data.id_plataforma == 3)
					this.textoBotonCodigo = 'Activar simulador'
			})

			Fire.$emit('asignaCodigosUsuario', this.codigosUsuario)
		},
		beforeMount() {
			document.body.classList.remove('bg-mos1')
			if(hostname == 'bpo.etciberoamerica.com') {
				this.classHeader = 'header bg-gradient-gray-dark pb-6 d-flex align-items-center'
				this.classTextWelcome = 'mt-0 mb-5 text-orange'
			}
			if(hostname == 'seducoahuila.etciberoamerica.com' || hostname == 'iproedomex.etciberoamerica.com' || hostname == 'ctm.etciberoamerica.com' || hostname == 'ipnpro.etciberoamerica.com' || hostname == 'tnmpro.etciberoamerica.com') {
				this.classHeader = 'header bg-gradient-gray-dark pb-6 d-flex align-items-center'
				this.classTextWelcome = 'mt-0 mb-5'
			}
		}
	}
</script>
